// footer accordion
if (window.matchMedia("(max-width: 760px)")) {
  document.addEventListener("DOMContentLoaded", () => {
    const linkTitle = document.querySelectorAll(".link-title");
    for (let i = 0; i < linkTitle.length; i++) {
      let titleEach = linkTitle[i];
      titleEach.addEventListener("click", () => {
        titleEach.classList.toggle("active");
      });
    }
  });
}

// Home Collections
const mediaQuery = window.matchMedia("(min-width: 641px)");
const createHomeCollectionCarousel = function (
  carouselRootSelector,
  carouselSelector,
  carouselBtnPrevSelector,
  carouselBtnNextSelector
) {
  const homeCollectionCarouselElement = document.querySelector(`${carouselRootSelector} ${carouselSelector}`);
  if (!homeCollectionCarouselElement) {
    return;
  }

  let homeCollectionCarousel = new Flickity(homeCollectionCarouselElement, {
    prevNextButtons: false,
    pageDots: false,
    wrapAround: false,
    contain: true,
    resize: true,
    cellAlign: "center",
    groupCells: 4,
  });

  // mobile init
  if (!mediaQuery.matches) {
    homeCollectionCarousel.destroy();
  }

  /*
  Resize
   */
  let resizeFlag = 500;
  let timeoutID = 0;
  window.addEventListener("resize", () => {
    resizeFlag = 500;
    clearTimeout(timeoutID);

    timeoutID = setTimeout(() => {
      homeCollectionCarousel.destroy();
      if (!mediaQuery.matches) {
        return;
      }
      homeCollectionCarousel = new Flickity(homeCollectionCarouselElement, {
        prevNextButtons: false,
        pageDots: false,
        wrapAround: false,
        contain: true,
        resize: true,
        cellAlign: "center",
        groupCells: 4,
      });

      carouselPrevBtnPc.style.visibility = "hidden";
      carouselNextBtnPc.style.visibility = "visible";

      homeCollectionCarousel.on("select", function () {
        const index = homeCollectionCarousel.selectedIndex;
        if (index === 0) {
          carouselPrevBtnPc.style.visibility = "hidden";
        } else {
          carouselPrevBtnPc.style.visibility = "visible";
        }
        if (index === homeCollectionCarousel.slides.length - 1) {
          carouselNextBtnPc.style.visibility = "hidden";
        } else {
          carouselNextBtnPc.style.visibility = "visible";
        }
      });
    }, resizeFlag);
  });

  /*
  Buttons
   */
  const carouselPrevBtnPc = document.querySelector(`${carouselRootSelector} ${carouselBtnPrevSelector}`);
  const carouselNextBtnPc = document.querySelector(`${carouselRootSelector} ${carouselBtnNextSelector}`);
  carouselPrevBtnPc.addEventListener("click", function () {
    homeCollectionCarousel.previous();
  });
  carouselNextBtnPc.addEventListener("click", function () {
    homeCollectionCarousel.next();
  });

  /*
  Events
   */
  // Initial visibility
  if (homeCollectionCarousel.slides.length <= 1) {
    carouselNextBtnPc.style.visibility = "hidden";
  }
  homeCollectionCarousel.on("select", function () {
    const index = homeCollectionCarousel.selectedIndex;
    if (index === 0) {
      carouselPrevBtnPc.style.visibility = "hidden";
    } else {
      carouselPrevBtnPc.style.visibility = "visible";
    }
    if (index === homeCollectionCarousel.slides.length - 1) {
      carouselNextBtnPc.style.visibility = "hidden";
    } else {
      carouselNextBtnPc.style.visibility = "visible";
    }
  });
};

const homeCollectionCarouselRootSelectors = Array.from(document.querySelectorAll(".home-collection-products")).map(
  (selector) => selector.id
);
homeCollectionCarouselRootSelectors.forEach((carouselRootSelector) => {
  createHomeCollectionCarousel(
    `#${carouselRootSelector}`,
    ".home-collection-products-carousel",
    ".home-collection-products-carousel-button.Previous",
    ".home-collection-products-carousel-button.Next"
  );
});

// Home News
const createHomeNewsCarousel = () => {
  const homeNewsCarouselElement = document.querySelector(".home-news-articles");
  if (homeNewsCarouselElement) {
    let homeNewsCarousel = new Flickity(homeNewsCarouselElement, {
      prevNextButtons: false,
      pageDots: false,
      wrapAround: false,
      contain: true,
      cellAlign: "left",
    });

    let resizeFlag = 500;
    let timeoutID = 0;
    window.addEventListener("resize", () => {
      resizeFlag = 500;
      clearTimeout(timeoutID);

      timeoutID = setTimeout(() => {
        homeNewsCarousel.destroy();
        homeNewsCarousel = new Flickity(homeNewsCarouselElement, {
          prevNextButtons: false,
          pageDots: false,
          wrapAround: false,
          contain: true,
          cellAlign: "left",
        });

        // button reset
        prevBtnPc.style.visibility = "hidden";
        prevBtnSp.style.opacity = "0.6";
        prevBtnSp.setAttribute("disabled", "true");
        nextBtnPc.style.visibility = "visible";
        nextBtnSp.style.opacity = "1";
        nextBtnSp.removeAttribute("disabled");

        homeNewsCarousel.on("select", function () {
          let index = homeNewsCarousel.selectedIndex;
          if (index === 0) {
            prevBtnPc.style.visibility = "hidden";
            prevBtnSp.style.opacity = "0.6";
            prevBtnSp.setAttribute("disabled", "true");
          } else {
            prevBtnPc.style.visibility = "visible";
            prevBtnSp.style.opacity = "1";
            prevBtnSp.removeAttribute("disabled");
          }
          if (index === homeNewsCarousel.slides.length - 1) {
            nextBtnPc.style.visibility = "hidden";
            nextBtnSp.style.opacity = "0.6";
            nextBtnSp.setAttribute("disabled", "true");
          } else {
            nextBtnPc.style.visibility = "visible";
            nextBtnSp.style.opacity = "1";
            nextBtnSp.removeAttribute("disabled");
          }
        });
      }, resizeFlag);
    });

    /*
    Buttons
     */
    const prevBtnPc = document.querySelector(".home-news-carousel-button.Pc.Previous");
    const nextBtnPc = document.querySelector(".home-news-carousel-button.Pc.Next");
    const prevBtnSp = document.querySelector(".home-news-carousel-button.Sp.Previous");
    const nextBtnSp = document.querySelector(".home-news-carousel-button.Sp.Next");
    prevBtnPc.addEventListener("click", function () {
      homeNewsCarousel.previous();
    });
    nextBtnPc.addEventListener("click", function () {
      homeNewsCarousel.next();
    });
    prevBtnSp.addEventListener("click", function () {
      homeNewsCarousel.previous();
    });
    nextBtnSp.addEventListener("click", function () {
      homeNewsCarousel.next();
    });

    /*
    Events
     */
    homeNewsCarousel.on("select", function () {
      let index = homeNewsCarousel.selectedIndex;
      if (index === 0) {
        prevBtnPc.style.visibility = "hidden";
        prevBtnSp.style.opacity = "0.6";
        prevBtnSp.setAttribute("disabled", "true");
      } else {
        prevBtnPc.style.visibility = "visible";
        prevBtnSp.style.opacity = "1";
        prevBtnSp.removeAttribute("disabled");
      }
      if (index === homeNewsCarousel.slides.length - 1) {
        nextBtnPc.style.visibility = "hidden";
        nextBtnSp.style.opacity = "0.6";
        nextBtnSp.setAttribute("disabled", "true");
      } else {
        nextBtnPc.style.visibility = "visible";
        nextBtnSp.style.opacity = "1";
        nextBtnSp.removeAttribute("disabled");
      }
    });
  }
};
createHomeNewsCarousel();

// Flickity
const rsCarousel = document.getElementById("rs-carousel");
if (rsCarousel) {
  const flkty = new Flickity(rsCarousel, {
    cellAlign: "left",
    pageDots: false,
    contain: true,
    arrowShape: {
      x0: 30,
      x1: 60,
      y1: 30,
      x2: 65,
      y2: 30,
      x3: 35,
    },
  });
}

const body = document.querySelector("body");
const zoomFrame = document.createElement("div");
zoomFrame.setAttribute("class", "zoom-frame");
const zoomImg = document.createElement("img");
const zoomClose = document.createElement("button");
zoomClose.classList.add("RoundButton");
zoomClose.insertAdjacentHTML(
  "afterbegin",
  `<svg class="Icon Icon--close" role="presentation" viewBox="0 0 16 14"><path d="M15 0L1 14m14 0L1 0" stroke="currentColor" fill="none" fill-rule="evenodd"></path></svg>`
);
zoomFrame.appendChild(zoomImg);
zoomFrame.appendChild(zoomClose);
body.appendChild(zoomFrame);
const zoomTarget = document.querySelectorAll(".rs-carousel-img");
Array.from(zoomTarget).forEach((b) => {
  b.addEventListener("click", (e) => {
    zoomImg.src = e.target.getAttribute("src");
    zoomFrame.classList.add("active");
  });
});

zoomClose.addEventListener("click", () => {
  zoomFrame.classList.remove("active");
});

// サブスク
let items = [];
const quantityTexts = Array.from(document.querySelectorAll(".quantity-text"));
const quantityButtons = Array.from(document.querySelectorAll(".quantity-button"));
const cartUpdate = document.getElementById("cartUpdate");
const cartDisaboled = document.getElementById("cartDisaboled");
const radioInputs = Array.from(document.querySelectorAll(".selling_plan"));
if (radioInputs[0]) radioInputs[0].checked = true; // ini

const findCheckedRadio = () => radioInputs.find((radio) => radio.checked);

const setQuantityText = (id, quantity) => {
  quantityTexts.forEach((text) => {
    if (text.getAttribute("variant_id") === id) text.textContent = quantity;
  });
  quantityButtons.forEach((button) => {
    if (button.getAttribute("variant_id") === id) button.setAttribute("quantity", quantity);
  });
};

const updateItems = (action, newItem) => {
  switch (action) {
    case "add":
      if (items.find((item) => item.id === newItem.id)) {
        items.forEach((item) => {
          const quantity = Number(item.quantity) + 1;
          if (item.id === newItem.id) {
            item.quantity = quantity;
            setQuantityText(newItem.id, item.quantity);
          }
        });
      } else {
        newItem.quantity = 1;
        items.push(newItem);
        setQuantityText(newItem.id, newItem.quantity);
      }
      break;

    case "decrease":
      if (items.find((item) => item.id === newItem.id)) {
        items.forEach((item, index) => {
          const quantity = Number(item.quantity) - 1;
          if (item.id === newItem.id) {
            if (quantity <= 0) {
              items.splice(index, 1);
              setQuantityText(newItem.id, 0);
            } else {
              item.quantity = quantity;
              setQuantityText(newItem.id, item.quantity);
            }
          }
        });
      }
      break;
    default:
      break;
  }

  checkForm();
};

quantityButtons.forEach((button) => {
  const type = button.getAttribute("data-action");
  const item = {
    id: button.getAttribute("variant_id"),
    quantity: 2,
  };

  button.addEventListener("click", (e) => {
    e.preventDefault();
    if (type === "add") {
      updateItems("add", item);
    }
    if (type === "decrease") {
      updateItems("decrease", item);
    }
  });
});

if (cartUpdate) {
  cartUpdate.addEventListener("click", (e) => {
    e.preventDefault();
    document.dispatchEvent(new CustomEvent("theme:loading:start"));
    const sellingPlancheckedInput = findCheckedRadio();
    const sellingPlanAddedItems = items.map((item) => ({ ...item, selling_plan: sellingPlancheckedInput.value }));

    console.log(sellingPlanAddedItems);

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify({ items: sellingPlanAddedItems }),
    })
      .then((response) => {
        document.dispatchEvent(new CustomEvent("theme:loading:end"));
        document.dispatchEvent(
          new CustomEvent("product:added", {
            bubbles: true,
            detail: {},
          })
        );
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  });
}

const checkForm = () => {
  let allQuantity = 0;
  items.forEach((item) => {
    allQuantity += item.quantity;
  });
  const length = allQuantity < 1 ? true : false;
  cartUpdate.setAttribute("data-show", !length);
  cartDisaboled.setAttribute("data-show", length);
};

function remove() {
  const cartSubscription = Array.from(document.querySelectorAll(".cartSubscription"));
  document.dispatchEvent(new CustomEvent("theme:loading:start"));
  (async () => {
    for (let i = 0; i < cartSubscription.length; i++) {
      const line = cartSubscription[i].value - i;

      await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
          line: line,
          quantity: 0,
        }),
      })
        .then((response) => {
          console.log(response);
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }
    document.dispatchEvent(new CustomEvent("theme:loading:end"));
    document.dispatchEvent(
      new CustomEvent("product:added", {
        bubbles: true,
        detail: {},
      })
    );
  })();
}
